import { TemplateComponents } from "./components-dto";
import { TemplateCategories } from "./template-categories.enum";

export class TemplateModel{
    name:string;
    category : TemplateCategories;
    allow_category_change : boolean;
    language : string;
    components : TemplateComponents[]
}